module.exports = "https://deal-img.imgix.net/consumer/modern/notification@2x.21f55047.png";